import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface BusinessAndLocationState {
  selectedBusinessId: string | null;
  selectedLocationId: string | null;
}

const initialState: BusinessAndLocationState = {
  selectedBusinessId: null,
  selectedLocationId: null,
};

const BusinessAndLocationSlice = createSlice({
  name: "BusinessAndLocationState",
  initialState,
  reducers: {
    setSelectedBusinessId: (state, action: PayloadAction<string>) => {
      state.selectedBusinessId = action.payload;
    },
    setSelectedLocationId: (state, action: PayloadAction<string>) => {
      state.selectedLocationId = action.payload;
    },
    resetBusinessAndLocation: (state) => {
      state.selectedBusinessId = null;
      state.selectedLocationId = null;
    },
  },
});

export const {
  setSelectedBusinessId,
  setSelectedLocationId,
  resetBusinessAndLocation,
} = BusinessAndLocationSlice.actions;

export default BusinessAndLocationSlice.reducer;
